import { createTheme, Theme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string;
    };
  }

  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}

type PaletteMode = 'light' | 'dark';

// Paleta de colores moderna - Inspirada en Apple Pay
const modernColors = {
  primary: '#1E3A8A', // Navy blue claro
  primaryLight: '#3B82F6',
  primaryDark: '#1E40AF',
  secondary: '#007AFF', // Azul Apple
  secondaryLight: '#5AC8FA',
  background: '#F2F2F7', // Gris claro Apple
  surface: '#FFFFFF',
  success: '#34C759',
  successLight: '#30D158',
  warning: '#FF9500',
  warningLight: '#FFCC02',
  error: '#FF3B30',
  errorLight: '#EF4444',
  info: '#0369A1',
  infoLight: '#0EA5E9',
  gray: '#F8FAFC',
  grayLight: '#FFFFFF',
  grayDark: '#E2E8F0',
  secure: '#065F46', // Verde oscuro para elementos de seguridad
} as const;

const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    primary: {
      main: modernColors.primary,
      light: modernColors.primaryLight,
      dark: modernColors.primaryDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: modernColors.secondary,
      light: modernColors.secondaryLight,
      dark: '#005FCC',
      contrastText: '#ffffff',
    },
    success: {
      main: modernColors.success,
      light: modernColors.successLight,
      dark: '#248A3D',
    },
    warning: {
      main: modernColors.warning,
      light: modernColors.warningLight,
      dark: '#CC7A00',
    },
    error: {
      main: modernColors.error,
      light: '#FF6961',
      dark: '#D70015',
    },
    info: {
      main: modernColors.secondary,
      light: modernColors.secondaryLight,
      dark: '#005FCC',
    },
    background: {
      default: mode === 'light' ? modernColors.background : '#000000',
      paper: mode === 'light' ? modernColors.surface : '#1C1C1E',
    },
    text: {
      primary: mode === 'light' ? '#111827' : '#F9FAFB',
      secondary: mode === 'light' ? '#6B7280' : '#9CA3AF',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.125rem',
      fontWeight: 700,
      lineHeight: 1.235,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.334,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.6,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
    },
  },
  shape: {
    borderRadius: 12, // Bordes más redondeados estilo Apple
  },
  spacing: 8,
  status: {
    danger: modernColors.error,
  },
});

// Create light and dark themes
export const lightTheme = createTheme(getDesignTokens('light'));
export const darkTheme = createTheme(getDesignTokens('dark'));

// Default theme (light)
const theme = lightTheme;

export { modernColors };
export default theme;
